import { useEffect, useState } from "react";
import { getBp } from "@core/utils/uiUtil";

export const useBreakpoint = () => {
  const [currentBp, setCurrentBp] = useState(getBp(window.innerWidth));

  useEffect(() => {
    let frameId: number | null = null;

    const onResize = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(() => {
        const nextBp = getBp(window.innerWidth);
        if (currentBp !== nextBp) {
          setCurrentBp(nextBp);
        }
        frameId = null;
      });
    };

    window.addEventListener("resize", onResize);

    // unmount 시 이벤트 제거
    return () => {
      if (frameId !== null) window.cancelAnimationFrame(frameId);
      window.removeEventListener("resize", onResize);
    };
  }, [currentBp]);

  return currentBp;
};
